<template>
  <!-- 待办任务 -->
  <div style="position: relative;">
    <el-form ref="formMyTask"  style="margin:5px 0" :model="formMyTask" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="发起时间" prop="formFilter.beginDate">
            <el-date-picker style="width:100%" v-model="formMyTask.formFilter.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目名称" prop="formFilter.projectName">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formMyTask.formFilter.projectName" placeholder="项目名称">
              <el-option
                v-for="item in projectList"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
            <el-button type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="flowEntry" :data="formMyTask.taskWidget.dataList" :size="defaultFormItemSize" @sort-change="formMyTask.taskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="formMyTask.taskWidget.getTableIndex" />
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px" />
          <el-table-column label="项目名称" prop="gcmc" width="600px" show-overflow-tooltip />
          <el-table-column label="供货方名称" prop="supplierName" width="200px" show-overflow-tooltip />
          <el-table-column label="合同编号" prop="contractNo" width="200px" show-overflow-tooltip />
          <el-table-column label="合同金额" prop="contractAmount" width="150px" show-overflow-tooltip />
          <el-table-column label="当前任务" prop="taskName" width="200px"  />
          <el-table-column label="发起时间" prop="processInstanceStartTime"  width="200px" />
          <el-table-column label="状态">
            <template slot-scope="scope">
               <span style="color:rgb(0, 128, 0)">处理中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text" @click="onSubmit(scope.row)">办理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="formMyTask.taskWidget.totalCount"
            :current-page="formMyTask.taskWidget.currentPage"
            :page-size="formMyTask.taskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="formMyTask.taskWidget.onCurrentPageChange"
            @size-change="formMyTask.taskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :visible="visible"
       width="1000px"
       top='5vh'
       :before-close="onClose"
    >
      <formTaskProcessViewer v-if="visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>
    
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';
import { ContractDeptController } from '@/api/index.js';
import formTaskProcessViewer from "./formTaskProcessViewer";
import { OnlineOperation } from '@/api/onlineController.js';

export default {
  name: 'formMyTask',
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  data () {
    return {
      formMyTask: {
        formFilter: {
          dateRange: undefined,
          projectName: undefined
        },
        formFilterCopy: {
          dateRange: undefined,
          projectName: undefined
        },
        taskWidget: new TableWidget(this.loadTaskData, this.loadTaskDataVerify, true, false, 'entryId', false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
        isInit: false
      },
      record:{},
      visible:false,
      projectList:[]
    }
  },
  created() {
    this.init()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onSubmit(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formMyTask.formFilter = search
      this.formMyTask.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  methods: {
    handleSearch(){
      this.refreshMyTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
    },
    onReset () {
      this.formMyTask.formFilter.projectName = ''
      this.formMyTask.formFilterCopy.projectName = ''
      this.formMyTask.formFilter.dateRange = undefined
      this.formMyTask.formFilterCopy.dateRange = undefined
      this.refreshMyTask(true);
    },
    loadTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify({pageParam:params.pageParam}))
      } else {
        localStorage.removeItem('page')
      }
      const dateRange = this.formMyTask.formFilterCopy.dateRange;
      params = {
        beginDate: dateRange ? dateRange[0] + ' 00:00:00' : undefined,
        endDate: dateRange ? dateRange[1] + ' 23:59:59' : undefined,
        projectName: this.formMyTask.formFilterCopy.projectName,
        ...params
      }
      return new Promise((resolve, reject) => {
        ContractDeptController.listRuntimeTask(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTaskDataVerify () {
      this.formMyTask.formFilterCopy.dateRange = this.formMyTask.formFilter.dateRange;
      this.formMyTask.formFilterCopy.projectName = this.formMyTask.formFilter.projectName;
      return true;
    },
    onSubmit (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      }
      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              // 过滤掉加签操作，加签只有在已完成任务里可以操作
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList,
              flowStatus:'未办结',
              form: true,
              serialNo: row.serialNo,
              data33: row.data33
            }
          });
        }
      }).catch(e => {});
    },
    refreshMyTask (reloadData = false) {
      if (reloadData) {
        this.formMyTask.taskWidget.refreshTable(true, 1);
      } else {
        this.formMyTask.taskWidget.refreshTable();
      }
      localStorage.setItem('search',JSON.stringify(this.formMyTask.formFilterCopy))
    },
    onResume () {
      this.refreshMyTask();
    },
    formInit () {
      this.refreshMyTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
